import { FC } from "react";
import { useRecoilState } from "recoil";
import { userState } from "../../atoms/user";
import { Navigate } from "react-router-dom";
import { adminState } from "../../atoms/isAdmin";

const RequireAdmin: FC<{ children: React.ReactElement }> = ({ children }) => {
  const [userInfo] = useRecoilState(userState);
  const [isAdmin] = useRecoilState(adminState);

  // Handle loading state - wait for admin state to be determined
  if (isAdmin === null || isAdmin === undefined) {
    return null;
  }

  // Redirect non-admins to home page
  if (!isAdmin) {
    console.log('requireadmin isAdmin', isAdmin);
    return <Navigate to="/" replace />;
  }

  console.log('requireadmin isAdmin', isAdmin);
  return children;
};

export default RequireAdmin;